import { ESCALATION_FIELDS_CONFIG } from "../config/escalationConfig";

export const getActionableFields = (config) => {
  const result = [];

  Object.values(config).forEach((group) => {
    group.fields.forEach((field) => {
      if (field.available_in_actions) {
        result.push({
          value: field.field_code,
          label: field.field_name,
          type: field.field_type,
          dataSource: field.data_source,
          apiEndpoint: field.api_endpoint || "",
          staticOptions: field.static_options || [],
          labelKey: field.label_key || "label",
          valueKey: field.value_key || "value",
        });
      }
    });
  });

  return result;
};


export const getAdditionalConditionFields = (config) => {
  const result = [];
  Object.values(config).forEach((group) => {
    const fields = [];
    group.fields.forEach((field) => {
      if (field.available_in_conditions) {
        fields.push({
          value: field.field_code,
          label: field.field_name,
          type: field.field_type,
          dataSource: field.data_source,
          apiEndpoint: field.api_endpoint || "",
          staticOptions: field.static_options || [],
          operators: field.operators || [],
          labelKey: field.label_key ,
          valueKey: field.value_key,
        });
      }
    });
    result.push({groupName: group.group_name,fields: fields});
  });
  return result;
};


function buildFieldNameMapFromConfig(config) {
  const map = {};
  Object.values(config).forEach(group => {
    if (group?.fields?.length) {
      group.fields.forEach(f => {
        map[f.field_code] = f.field_name;
      });
    }
  });
  return map;
}

export const ESCALATION_FIELD_NAME_MAP = buildFieldNameMapFromConfig(ESCALATION_FIELDS_CONFIG);